import React from 'react';
import "./Article.scss";
import { Link } from 'react-router-dom';

const Article = ({ image, title, description, img, width }) => {

    const data = {image, title, description, img}

    return (
        <div className="article" style={{width: `${width}`}}>
            <div className="article__container-image">
                <img src={image} alt="Articulo" />
            </div>
            <h2>{title}</h2>
            <p>{description}</p>
            <Link exact className="article__button" to={{
                pathname: `/${title.toLowerCase().split(" ").join("-")}`, state: { data }
            }}>VER MÁS</Link>
        </div>
    )
}

export default Article;
